import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Container, Dialog, Fade, Grid } from '@material-ui/core'
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite'
import EditableHTML from '@v4/components/common/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import SortHandler from '@v4/components/common/SortHandler'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import Image from '@v4/components/common/Image'
import { VideoBlock } from '../../../Video'
import { useBanner13 } from './Banner13.hooks'

const Banner13 = props => {
	const [
		{
			classes,
			open,
			direction,
			withModal,
			video,
			isMobile,
			additionalButtonColor,
			image,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonTextConfig,
			buttonAction,
			buttonLink,
			buttonTextKey,
			buttonTextEditable,

			additionalButtonText,
			additionalButtonTextKey,
			additionalButtonTextConfig,
			additionalButtonAction,
			additionalButtonLink,
			additionalButtonTextEditable,
		},
		{
			handleToggleModal,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,

			handleAdditionalButtonClick,
			handleAdditionalButtonTextChange,
		},
	] = useBanner13(props)

	return (
		<>
			{!isMobile && (
				<div className={clsx(classes.bgSection, 'banner13-background-section')}>
					<Container className={clsx(classes.bgContainer, 'banner13-background-container')}>
						<Grid container className={clsx(classes.bgGrid, 'banner13-background-grid')}>
							<SortHandler direction={direction}>
								<Grid item lg={6} md={6} sm={12} xs={12} className="banner13-background-container">
									<Image
										onClick={withModal ? handleToggleModal : undefined}
										className={clsx(
											classes.background,
											withModal && classes.withVideo,
											'banner13-background',
										)}
										metaData={image}
										isBackground
									>
										{withModal && (
											<PlayCircleFilledWhiteIcon
												className={clsx(classes.icon, 'banner13-icon')}
											/>
										)}
									</Image>
								</Grid>
								<Grid item lg={6} md={6} />
							</SortHandler>
						</Grid>
					</Container>
				</div>
			)}
			<Grid container className="banner13-root" spacing={3}>
				<SortHandler direction={direction}>
					<Grid item lg={6} md={6} sm={12} xs={12}>
						{isMobile && (
							<Image
								onClick={withModal ? handleToggleModal : undefined}
								className={clsx(
									classes.background,
									withModal && classes.withVideo,
									'banner13-background',
								)}
								metaData={image}
								isBackground
							>
								{withModal && (
									<PlayCircleFilledWhiteIcon className={clsx(classes.icon, 'banner13-icon')} />
								)}
							</Image>
						)}
					</Grid>
					<Grid item lg={6} md={6} sm={12} xs={12} className={clsx('banner13-content-container')}>
						<div className={clsx(classes.content, 'banner13-content')}>
							<Box className={clsx(classes.textWrapper, 'banner13-text-wrapper')}>
								<EditableContainer
									visible={!!text}
									fieldConfig={textConfig}
									onAdd={handleTextChange}
									editable={textEditable}
									wrapper={({ children }) => (
										<Box width="100%" mb={4}>
											{children}
										</Box>
									)}
								>
									<EditableHTML
										key={textKey}
										className={clsx(classes.text, 'banner13-text-block')}
										html={text}
										onClick={handleTextClick}
										editable={textEditable}
										onChange={handleTextChange}
									/>
								</EditableContainer>
							</Box>
							<div className={clsx(classes.buttonsWrap, 'banner13-buttons-wrap')}>
								<EditableContainer
									visible={!!buttonText}
									fieldConfig={buttonTextConfig}
									onAdd={handleButtonTextChange}
									editable={buttonTextEditable}
									label="Button"
								>
									<ActionButton
										key={buttonTextKey}
										action={buttonAction}
										href={buttonLink}
										editable={buttonTextEditable}
										onClick={handleButtonClick}
										onChange={handleButtonTextChange}
										className={clsx(classes.button, 'banner13-button')}
									>
										{buttonText}
									</ActionButton>
								</EditableContainer>

								<EditableContainer
									visible={!!additionalButtonText}
									fieldConfig={additionalButtonTextConfig}
									onAdd={handleAdditionalButtonTextChange}
									editable={additionalButtonTextEditable}
									label="Button"
								>
									<ActionButton
										key={additionalButtonTextKey}
										action={additionalButtonAction}
										href={additionalButtonLink}
										className={clsx(
											classes.button,
											classes.additionalButton,
											'banner13-additional-button',
										)}
										onClick={handleAdditionalButtonClick}
										editable={additionalButtonTextEditable}
										onChange={handleAdditionalButtonTextChange}
										variant="outlined"
										primaryColor={additionalButtonColor}
									>
										{additionalButtonText}
									</ActionButton>
								</EditableContainer>
							</div>
						</div>
					</Grid>
				</SortHandler>
			</Grid>
			<Dialog
				open={open && withModal}
				onClose={handleToggleModal}
				maxWidth="md"
				PaperProps={{ className: classes.modal }}
				className="banner13-modal"
			>
				<Fade in={open && withModal}>
					<VideoBlock className="banner13-video-block" value={video} />
				</Fade>
			</Dialog>
		</>
	)
}

Banner13.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		video: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		image: PropTypes.instanceOf(PageMetaData),
		videoPosition: PropTypes.instanceOf(PageMetaData),
		additionalButtonText: PropTypes.instanceOf(PageMetaData),
		additionalButtonLink: PropTypes.instanceOf(PageMetaData),
		additionalButtonAction: PropTypes.instanceOf(PageMetaData),
		additionalButtonColor: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Banner13)
